// @ts-check
import Permission from '@/store/modules/models/global/Permission';
import SharingSummary from '@/store/modules/users/models/SharingSummary';

const Sharing = SharingSummary.extend({
  everyone_permission: Permission.nullable(),
});

export default Sharing;
